import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mt-2" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "mt-2" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "d-flex" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "mt-2" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { class: "d-flex" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 1,
  class: "justify-left"
}
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = { class: "text-center" }
const _hoisted_24 = { class: "text-center" }
const _hoisted_25 = { class: "bg-white px-8 py-5 rounded-lg elevation-3 overflow-auto" }
const _hoisted_26 = { class: "text-h5 pb-2" }
const _hoisted_27 = { class: "text-h4 pa-3" }
const _hoisted_28 = {
  key: 0,
  class: "text-center"
}
const _hoisted_29 = {
  key: 1,
  class: "text-center",
  style: {"word-wrap":"break-word"}
}
const _hoisted_30 = { style: {"font-size":"1.3rem"} }
const _hoisted_31 = { class: "progress" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "border rounded-lg bg-white overflow-hidden" }
const _hoisted_34 = { class: "pa-3 bg-grey-lighten-4 d-flex justify-space-between" }
const _hoisted_35 = { class: "pa-4" }

import {onBeforeMount, ref, watch} from "vue";
import externalAccountHelper from '../service/ExternalAccountHelperService';
import taskHelper from '../service/TaskHelperService';
import createDatabaseHelper from "../service/createDatabaseHelper";
import {onBeforeRouteUpdate} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'ExternalAccountComponent',
  setup(__props) {


const externalAccountHelperData = ref(externalAccountHelper);
const createDatabaseHelperData = ref(createDatabaseHelper);
const createQuestionModal = ref(false);
const sftpAuthType = ref([
  {id: 'password', name: 'Username & Password'},
  {id: 'key', name: 'RSA Key'}
]);
const s3AuthMethod = ref([
  {id: 'pool_id', name: 'Identity Pool ID'},
  {id: 'access_key', name: 'Access Key'}]);
const taskHelperData = ref(taskHelper);
const isActiveModal = ref<any>(false);
const regionList = ref<any>([...externalAccountHelperData.value.regionList])

onBeforeRouteUpdate(async (to,from,next) => {
  await taskHelperData.value.reload();
  externalAccountHelperData.value.region = null;
  next();
})

onBeforeMount(async () => {
  await load();
})

watch(() => taskHelperData.value.modalTask, () => {
  taskHelperData.value.modalVisible = taskHelperData.value.modalTask != null;
});

watch(() => taskHelperData.value.modalPlaceholder, (newVal,oldVal) => {
  if (newVal !== '') {
    taskHelperData.value.modalVisible = true;
  }
});

watch(() => taskHelperData.value.modalVisible, (newVal,oldVal) => {
  if (taskHelperData.value.modalVisible === false) {
    taskHelperData.value.modalTask = null;
    window.location.reload();
  }
  if (newVal === false && oldVal === true) {
    taskHelperData.value.modalPlaceholder = '';
    for (let f of taskHelperData.value.onModalClose) {
      // this.taskHelper.$timeout(f, 1000);
    }
    taskHelperData.value.onModalClose = [];
  }
});

function closeModal() {
  externalAccountHelperData.value.modalFTPVisible = false;
  externalAccountHelperData.value.modalSFTPVisible = false;
  externalAccountHelperData.value.modalS3Visible = false;
  externalAccountHelperData.value.modalVisible = false;
}
async function load() {
  if (window.location.pathname != '/crapp/scan/edit/') {
    await taskHelperData.value.init();
    await taskHelperData.value.reload();
  }
}



return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      modelValue: externalAccountHelperData.value.modalFTPVisible,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((externalAccountHelperData.value.modalFTPVisible) = $event)),
      width: "500"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "d-flex" }, {
              default: _withCtx(() => [
                _cache[50] || (_cache[50] = _createTextVNode(" Link External Accounts ", -1 /* CACHED */)),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_icon, {
                  onClick: closeModal,
                  size: "x-small",
                  icon: "mdi-window-close"
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createElementVNode("form", {
                  onSubmit: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"]))
                }, [
                  _withDirectives(_createVNode(_component_v_alert, {
                    id: "showFtpErr",
                    type: "error",
                    density: "compact"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vShow, externalAccountHelperData.value.showFtpErr]
                  ]),
                  _createElementVNode("div", _hoisted_1, [
                    _cache[51] || (_cache[51] = _createElementVNode("label", { class: "font-weight-bold" }, "FTP Server", -1 /* CACHED */)),
                    _createVNode(_component_v_text_field, {
                      class: "mt-1",
                      variant: "outlined",
                      density: "compact",
                      modelValue: externalAccountHelperData.value.ftpServerParse,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((externalAccountHelperData.value.ftpServerParse) = $event)),
                      placeholder: "ftp.yourdomain.com / IP Address"
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[52] || (_cache[52] = _createElementVNode("label", { class: "font-weight-bold" }, "FTP Username", -1 /* CACHED */)),
                    _createVNode(_component_v_text_field, {
                      class: "mt-1",
                      variant: "outlined",
                      density: "compact",
                      modelValue: externalAccountHelperData.value.ftpUser,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((externalAccountHelperData.value.ftpUser) = $event))
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[53] || (_cache[53] = _createElementVNode("label", { class: "font-weight-bold" }, "FTP Password", -1 /* CACHED */)),
                    _createVNode(_component_v_text_field, {
                      class: "mt-1",
                      variant: "outlined",
                      density: "compact",
                      modelValue: externalAccountHelperData.value.ftpPassword,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((externalAccountHelperData.value.ftpPassword) = $event))
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[54] || (_cache[54] = _createElementVNode("label", { class: "font-weight-bold" }, "FTP Port", -1 /* CACHED */)),
                    _createVNode(_component_v_text_field, {
                      class: "mt-1",
                      variant: "outlined",
                      density: "compact",
                      modelValue: externalAccountHelperData.value.ftpPort,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((externalAccountHelperData.value.ftpPort) = $event))
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_2, [
                    (externalAccountHelperData.value.externalAccountId)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createVNode(_component_v_btn, {
                            disabled: externalAccountHelperData.value.isProcessing,
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (externalAccountHelperData.value.doEditFtp())),
                            color: "black",
                            variant: "flat"
                          }, {
                            default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                              _createTextVNode("Save", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["disabled"])
                        ]))
                      : _createCommentVNode("v-if", true),
                    (!externalAccountHelperData.value.externalAccountId)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createVNode(_component_v_btn, {
                            variant: "flat",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (externalAccountHelperData.value.doCreateFtp())),
                            color: "black",
                            class: "text-none mr-3"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(externalAccountHelperData.value.ftpType === 'sftp' ? 'add SFTP Account' : 'add FTP account'), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createVNode(_component_v_btn, {
                      variant: "flat",
                      color: "#DAD7D7",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (externalAccountHelperData.value.modalFTPVisible = false)),
                      class: "text-none ml-2"
                    }, {
                      default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                        _createTextVNode("Cancel", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ])
                ], 32 /* NEED_HYDRATION */)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: externalAccountHelperData.value.modalSFTPVisible,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((externalAccountHelperData.value.modalSFTPVisible) = $event)),
      width: "500"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "d-flex" }, {
              default: _withCtx(() => [
                _cache[57] || (_cache[57] = _createTextVNode(" Link External Accounts ", -1 /* CACHED */)),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_icon, {
                  onClick: closeModal,
                  size: "x-small",
                  icon: "mdi-window-close"
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_divider, { class: "my-1" }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createElementVNode("form", {
                  onSubmit: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["prevent"]))
                }, [
                  _withDirectives(_createVNode(_component_v_alert, {
                    id: "showSftpErr",
                    type: "error",
                    density: "compact"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vShow, externalAccountHelperData.value.showSftpErr]
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _cache[58] || (_cache[58] = _createElementVNode("label", { class: "font-weight-bold" }, "Authorization Method", -1 /* CACHED */)),
                    _createVNode(_component_v_select, {
                      class: "mt-1",
                      modelValue: externalAccountHelperData.value.sftpAuthType,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((externalAccountHelperData.value.sftpAuthType) = $event)),
                      variant: "outlined",
                      density: "compact",
                      items: sftpAuthType.value,
                      "item-value": "id",
                      "item-title": "name"
                    }, null, 8 /* PROPS */, ["modelValue", "items"])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[59] || (_cache[59] = _createElementVNode("label", { class: "font-weight-bold" }, "Server", -1 /* CACHED */)),
                    _createVNode(_component_v_text_field, {
                      class: "mt-1",
                      variant: "outlined",
                      density: "compact",
                      modelValue: externalAccountHelperData.value.ftpServerParse,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((externalAccountHelperData.value.ftpServerParse) = $event)),
                      placeholder: "sftp.yourdomain.com / IP Address"
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[60] || (_cache[60] = _createElementVNode("label", { class: "font-weight-bold" }, "Username", -1 /* CACHED */)),
                    _createVNode(_component_v_text_field, {
                      class: "mt-1",
                      variant: "outlined",
                      density: "compact",
                      modelValue: externalAccountHelperData.value.ftpUser,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((externalAccountHelperData.value.ftpUser) = $event))
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  (externalAccountHelperData.value.sftpAuthType === 'key')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _cache[61] || (_cache[61] = _createElementVNode("label", { class: "font-weight-bold" }, "RSA Key", -1 /* CACHED */)),
                        _createVNode(_component_v_textarea, {
                          class: "mt-1",
                          variant: "outlined",
                          density: "compact",
                          modelValue: externalAccountHelperData.value.sftpKey,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((externalAccountHelperData.value.sftpKey) = $event))
                        }, null, 8 /* PROPS */, ["modelValue"])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (externalAccountHelperData.value.sftpAuthType === 'key')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _cache[62] || (_cache[62] = _createElementVNode("label", { class: "font-weight-bold" }, "Key Phrase", -1 /* CACHED */)),
                        _createVNode(_component_v_text_field, {
                          class: "mt-1",
                          variant: "outlined",
                          density: "compact",
                          modelValue: externalAccountHelperData.value.sftpKeyPhrase,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((externalAccountHelperData.value.sftpKeyPhrase) = $event))
                        }, null, 8 /* PROPS */, ["modelValue"])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (externalAccountHelperData.value.sftpAuthType === 'password')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _cache[63] || (_cache[63] = _createElementVNode("label", { class: "font-weight-bold" }, "Password", -1 /* CACHED */)),
                        _createVNode(_component_v_text_field, {
                          class: "mt-1",
                          variant: "outlined",
                          density: "compact",
                          modelValue: externalAccountHelperData.value.sftpPassword,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((externalAccountHelperData.value.sftpPassword) = $event))
                        }, null, 8 /* PROPS */, ["modelValue"])
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", null, [
                    _cache[64] || (_cache[64] = _createElementVNode("label", { class: "font-weight-bold" }, "Port", -1 /* CACHED */)),
                    _createVNode(_component_v_text_field, {
                      class: "mt-1",
                      variant: "outlined",
                      density: "compact",
                      modelValue: externalAccountHelperData.value.ftpPort,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((externalAccountHelperData.value.ftpPort) = $event))
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    (externalAccountHelperData.value.externalAccountId)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createVNode(_component_v_btn, {
                            disabled: externalAccountHelperData.value.isProcessing,
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (externalAccountHelperData.value.doEditSftp())),
                            color: "black",
                            variant: "flat"
                          }, {
                            default: _withCtx(() => [...(_cache[65] || (_cache[65] = [
                              _createTextVNode("Save", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["disabled"])
                        ]))
                      : _createCommentVNode("v-if", true),
                    (!externalAccountHelperData.value.externalAccountId)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createVNode(_component_v_btn, {
                            variant: "flat",
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (externalAccountHelperData.value.doCreateSftp())),
                            color: "black",
                            class: "text-none mr-3"
                          }, {
                            default: _withCtx(() => [...(_cache[66] || (_cache[66] = [
                              _createTextVNode(" Add SFTP account ", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          })
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createVNode(_component_v_btn, {
                      variant: "flat",
                      color: "#DAD7D7",
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (externalAccountHelperData.value.modalSFTPVisible = false)),
                      class: "text-none ml-2"
                    }, {
                      default: _withCtx(() => [...(_cache[67] || (_cache[67] = [
                        _createTextVNode("Cancel", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ])
                ], 32 /* NEED_HYDRATION */)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: externalAccountHelperData.value.modalS3Visible,
      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((externalAccountHelperData.value.modalS3Visible) = $event)),
      width: "500"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "d-flex" }, {
              default: _withCtx(() => [
                _cache[68] || (_cache[68] = _createTextVNode(" Link External Accounts ", -1 /* CACHED */)),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_icon, {
                  onClick: closeModal,
                  size: "x-small",
                  icon: "mdi-window-close"
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_divider, { class: "my-1" }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createElementVNode("form", {
                  onSubmit: _cache[30] || (_cache[30] = _withModifiers(() => {}, ["prevent"]))
                }, [
                  _withDirectives(_createVNode(_component_v_alert, {
                    id: "showS3Err",
                    type: "error",
                    density: "compact"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vShow, externalAccountHelperData.value.showS3Err]
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[69] || (_cache[69] = _createElementVNode("label", { class: "font-weight-bold" }, "AWS S3 Authorization Method", -1 /* CACHED */)),
                    _createVNode(_component_v_select, {
                      class: "mt-1",
                      modelValue: externalAccountHelperData.value.s3AuthType,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((externalAccountHelperData.value.s3AuthType) = $event)),
                      variant: "outlined",
                      density: "compact",
                      items: s3AuthMethod.value,
                      "item-value": "id",
                      "item-title": "name"
                    }, null, 8 /* PROPS */, ["modelValue", "items"])
                  ]),
                  (externalAccountHelperData.value.s3AuthType == 'pool_id')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _cache[70] || (_cache[70] = _createElementVNode("label", { class: "font-weight-bold" }, "Identity Pool ID", -1 /* CACHED */)),
                        _createVNode(_component_v_text_field, {
                          class: "mt-1",
                          variant: "outlined",
                          density: "compact",
                          modelValue: externalAccountHelperData.value.identityPoolId,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((externalAccountHelperData.value.identityPoolId) = $event))
                        }, null, 8 /* PROPS */, ["modelValue"])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (externalAccountHelperData.value.s3AuthType == 'access_key')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _cache[71] || (_cache[71] = _createElementVNode("label", { class: "font-weight-bold align-center" }, "Access Key ID", -1 /* CACHED */)),
                        _createVNode(_component_v_text_field, {
                          class: "mt-1",
                          variant: "outlined",
                          density: "compact",
                          modelValue: externalAccountHelperData.value.accessKey,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((externalAccountHelperData.value.accessKey) = $event))
                        }, null, 8 /* PROPS */, ["modelValue"])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (externalAccountHelperData.value.s3AuthType === 'access_key')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _cache[72] || (_cache[72] = _createElementVNode("label", { class: "font-weight-bold" }, "Secret Access Key", -1 /* CACHED */)),
                        _createVNode(_component_v_text_field, {
                          class: "mt-1",
                          variant: "outlined",
                          density: "compact",
                          modelValue: externalAccountHelperData.value.secretToken,
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((externalAccountHelperData.value.secretToken) = $event))
                        }, null, 8 /* PROPS */, ["modelValue"])
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", null, [
                    _cache[73] || (_cache[73] = _createElementVNode("label", { class: "font-weight-bold" }, "Region", -1 /* CACHED */)),
                    _createVNode(_component_v_autocomplete, {
                      class: "mt-1",
                      variant: "outlined",
                      modelValue: externalAccountHelperData.value.region,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((externalAccountHelperData.value.region) = $event)),
                      density: "compact",
                      items: regionList.value,
                      "item-value": "id",
                      "item-title": "name",
                      label: "Please Select",
                      clearable: ""
                    }, null, 8 /* PROPS */, ["modelValue", "items"])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[74] || (_cache[74] = _createElementVNode("label", { class: "font-weight-bold" }, "Bucket name", -1 /* CACHED */)),
                    _createVNode(_component_v_text_field, {
                      class: "mt-1",
                      variant: "outlined",
                      density: "compact",
                      modelValue: externalAccountHelperData.value.bucketname,
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((externalAccountHelperData.value.bucketname) = $event))
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    (externalAccountHelperData.value.externalAccountId)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createVNode(_component_v_btn, {
                            disabled: externalAccountHelperData.value.isProcessing,
                            onClick: _cache[27] || (_cache[27] = ($event: any) => (externalAccountHelperData.value.doEditS3())),
                            color: "black",
                            variant: "flat"
                          }, {
                            default: _withCtx(() => [...(_cache[75] || (_cache[75] = [
                              _createTextVNode("Save", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["disabled"])
                        ]))
                      : _createCommentVNode("v-if", true),
                    (!externalAccountHelperData.value.externalAccountId)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createVNode(_component_v_btn, {
                            variant: "flat",
                            onClick: _cache[28] || (_cache[28] = ($event: any) => (externalAccountHelperData.value.doCreateS3())),
                            color: "black",
                            class: "text-none mr-3",
                            "prepend-icon": "mdi-aws"
                          }, {
                            default: _withCtx(() => [...(_cache[76] || (_cache[76] = [
                              _createTextVNode(" Add S3 account ", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          })
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createVNode(_component_v_btn, {
                      variant: "flat",
                      color: "#DAD7D7",
                      onClick: _cache[29] || (_cache[29] = ($event: any) => (externalAccountHelperData.value.modalS3Visible = false)),
                      class: "text-none ml-2"
                    }, {
                      default: _withCtx(() => [...(_cache[77] || (_cache[77] = [
                        _createTextVNode("Cancel", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ])
                ], 32 /* NEED_HYDRATION */)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: externalAccountHelperData.value.modalVisible,
      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((externalAccountHelperData.value.modalVisible) = $event)),
      "max-width": "800"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "d-flex flex-wrap" }, {
              default: _withCtx(() => [
                _cache[78] || (_cache[78] = _createTextVNode(" Add File Storage ", -1 /* CACHED */)),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_icon, {
                  onClick: closeModal,
                  size: "x-small",
                  icon: "mdi-window-close"
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_divider, { class: "my-2" }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { class: "d-flex justify-center" }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_v_col, {
                      lg: "4",
                      md: "4",
                      cols: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          onClick: _cache[32] || (_cache[32] = ($event: any) => (externalAccountHelperData.value.doCreateDropbox())),
                          style: {"cursor":"pointer","max-width":"13rem"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_item, null, {
                              default: _withCtx(() => [
                                _createElementVNode("h1", _hoisted_19, [
                                  _createVNode(_component_v_icon, { icon: "mdi-dropbox" })
                                ]),
                                _cache[79] || (_cache[79] = _createElementVNode("h4", { class: "text-center" }, "Dropbox Account", -1 /* CACHED */))
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }, 512 /* NEED_PATCH */), [
                      [_vShow, externalAccountHelperData.value.showDropbox]
                    ]),
                    _withDirectives(_createVNode(_component_v_col, {
                      lg: "4",
                      md: "4",
                      cols: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          onClick: _cache[33] || (_cache[33] = ($event: any) => (externalAccountHelperData.value.createFTP())),
                          style: {"cursor":"pointer","max-width":"13rem"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_item, null, {
                              default: _withCtx(() => [
                                _createElementVNode("h1", _hoisted_20, [
                                  _createVNode(_component_v_icon, { icon: "mdi-server" })
                                ]),
                                _cache[80] || (_cache[80] = _createElementVNode("h4", { class: "text-center" }, "FTP Account", -1 /* CACHED */))
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }, 512 /* NEED_PATCH */), [
                      [_vShow, externalAccountHelperData.value.showAllOptions]
                    ]),
                    _withDirectives(_createVNode(_component_v_col, {
                      lg: "4",
                      md: "4",
                      cols: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          onClick: _cache[34] || (_cache[34] = ($event: any) => (externalAccountHelperData.value.createSFTP())),
                          style: {"cursor":"pointer","max-width":"13rem"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_item, null, {
                              default: _withCtx(() => [
                                _createElementVNode("h1", _hoisted_21, [
                                  _createVNode(_component_v_icon, { icon: "mdi-server" })
                                ]),
                                _cache[81] || (_cache[81] = _createElementVNode("h4", { class: "text-center" }, "SFTP Account", -1 /* CACHED */))
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }, 512 /* NEED_PATCH */), [
                      [_vShow, externalAccountHelperData.value.showSftp]
                    ]),
                    _withDirectives(_createVNode(_component_v_col, {
                      lg: "4",
                      md: "4",
                      cols: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          onClick: _cache[35] || (_cache[35] = ($event: any) => (externalAccountHelperData.value.createS3())),
                          style: {"cursor":"pointer","max-width":"13rem"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_item, null, {
                              default: _withCtx(() => [
                                _createElementVNode("h1", _hoisted_22, [
                                  _createVNode(_component_v_icon, { icon: "mdi-aws" })
                                ]),
                                _cache[82] || (_cache[82] = _createElementVNode("h4", { class: "text-center" }, "S3 Account", -1 /* CACHED */))
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }, 512 /* NEED_PATCH */), [
                      [_vShow, externalAccountHelperData.value.showAllOptions]
                    ]),
                    _withDirectives(_createVNode(_component_v_col, {
                      lg: "4",
                      md: "4",
                      cols: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          onClick: _cache[36] || (_cache[36] = ($event: any) => (externalAccountHelperData.value.doCreateGoogleDrive())),
                          style: {"cursor":"pointer","max-width":"13rem"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_item, null, {
                              default: _withCtx(() => [
                                _createElementVNode("h1", _hoisted_23, [
                                  _createVNode(_component_v_icon, { icon: "mdi-google" })
                                ]),
                                _cache[83] || (_cache[83] = _createElementVNode("h4", { class: "text-center" }, "Google Drive", -1 /* CACHED */))
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }, 512 /* NEED_PATCH */), [
                      [_vShow, externalAccountHelperData.value.showGoogle]
                    ]),
                    _withDirectives(_createVNode(_component_v_col, {
                      lg: "4",
                      md: "4",
                      cols: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          onClick: _cache[37] || (_cache[37] = ($event: any) => (externalAccountHelperData.value.doCreateBox())),
                          style: {"cursor":"pointer","max-width":"13rem"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_item, null, {
                              default: _withCtx(() => [
                                _createElementVNode("h1", _hoisted_24, [
                                  _createVNode(_component_v_icon, { icon: "mdi-box" })
                                ]),
                                _cache[84] || (_cache[84] = _createElementVNode("h4", { class: "text-center" }, "Box Account", -1 /* CACHED */))
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }, 512 /* NEED_PATCH */), [
                      [_vShow, externalAccountHelperData.value.showBox]
                    ])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_divider, { class: "my-2" }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "flat",
                  color: "black",
                  class: "text-none mr-3",
                  onClick: _cache[38] || (_cache[38] = ($event: any) => (externalAccountHelperData.value.modalVisible = false))
                }, {
                  default: _withCtx(() => [...(_cache[85] || (_cache[85] = [
                    _createTextVNode("Done", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"]),
    _createCommentVNode("External account"),
    _createVNode(_component_v_dialog, {
      modelValue: taskHelperData.value.modalVisible,
      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((taskHelperData.value.modalVisible) = $event)),
      width: "500",
      class: "pt-3"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_v_icon, {
              onClick: _cache[40] || (_cache[40] = ($event: any) => (taskHelperData.value.modalVisible=false)),
              style: {"float":"right"},
              size: "x-small",
              icon: "mdi-window-close"
            })
          ]),
          _createElementVNode("div", _hoisted_27, [
            (taskHelperData.value.modalTask == null && taskHelperData.value.modalPlaceholder != '')
              ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(taskHelperData.value.modalPlaceholder), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            (taskHelperData.value && taskHelperData.value.modalTask != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        lg: "12",
                        md: "12",
                        sm: "12",
                        xs: "12"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_30, _toDisplayString(taskHelperData.value.modalTask['taskStatus']['response']), 1 /* TEXT */),
                          (taskHelperData.value.modalTask['taskStatus']['status'] == 0)
                            ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                                key: 0,
                                color: "black",
                                indeterminate: "",
                                rounded: "",
                                height: "6"
                              }))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                      }),
                      (taskHelperData.value.modalTask['taskStatus']['status'] == 2)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 0,
                            lg: "12",
                            md: "12",
                            sm: "12",
                            xs: "12"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_31, [
                                _createVNode(_component_v_row, {
                                  class: "fill-height",
                                  "align-content": "center",
                                  justify: "center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      class: "text-subtitle-1 text-center",
                                      cols: "12"
                                    }),
                                    _createVNode(_component_v_col, { cols: "6" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_progress_linear, {
                                          color: "black",
                                          indeterminate: "",
                                          rounded: "",
                                          height: "6"
                                        })
                                      ]),
                                      _: 1 /* STABLE */
                                    })
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ])
                            ]),
                            _: 1 /* STABLE */
                          }))
                        : _createCommentVNode("v-if", true),
                      (taskHelperData.value.modalTask['taskStatus']['status'] == 1 && taskHelperData.value.modalTask['taskStatus']['url'] !== undefined)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 1,
                            lg: "12",
                            md: "12",
                            sm: "12",
                            xs: "12"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_v_btn, {
                                  "prepend-icon": "mdi-download",
                                  onClick: _cache[41] || (_cache[41] = ($event: any) => (taskHelperData.value.downloadFile(taskHelperData.value.modalTask['historyId'], taskHelperData.value.modalTask['type']))),
                                  variant: "flat",
                                  color: "black",
                                  class: "text-none"
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, { icon: "mdi-download" })
                                  ]),
                                  default: _withCtx(() => [
                                    _cache[86] || (_cache[86] = _createTextVNode(" Download ", -1 /* CACHED */))
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ])
                            ]),
                            _: 1 /* STABLE */
                          }))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_divider, { class: "mt-3" }),
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: 3 }, {
                        default: _withCtx(() => [
                          (taskHelperData.value.modalTask && taskHelperData.value.modalTask['taskInfo'] && taskHelperData.value.modalTask['taskInfo'] !== undefined && Object.keys(taskHelperData.value.modalTask['taskInfo']).length > 0 && taskHelperData.value.modalTask['taskInfo'] !== '')
                            ? (_openBlock(), _createBlock(_component_v_card_actions, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_tooltip, {
                                    target: taskHelperData.value.modalTask && '#popover-task-info-' + taskHelperData.value.modalTask['historyId'],
                                    location: "top",
                                    "open-on-focus": true,
                                    "open-on-hover": true
                                  }, {
                                    activator: _withCtx(({props}) => [
                                      _createElementVNode("div", null, [
                                        _createVNode(_component_v_btn, _mergeProps({
                                          id: 'popover-task-info' + (taskHelperData.value.modalTask ? taskHelperData.value.modalTask['historyId']: ''),
                                          variant: "flat",
                                          color: "black",
                                          size: "small"
                                        }, props, { class: "text-none" }), {
                                          default: _withCtx(() => [...(_cache[87] || (_cache[87] = [
                                            _createTextVNode("More Info", -1 /* CACHED */)
                                          ]))]),
                                          _: 1 /* STABLE */
                                        }, 16 /* FULL_PROPS */, ["id"])
                                      ])
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("div", null, [
                                        (taskHelperData.value && taskHelperData.value.modalTask['taskInfo'])
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_32, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taskHelperData.value.modalTask['taskInfo'], (value, key) => {
                                                return (_openBlock(), _createElementBlock("span", null, [
                                                  _createTextVNode(_toDisplayString(key) + ": " + _toDisplayString(value) + " ", 1 /* TEXT */),
                                                  _cache[88] || (_cache[88] = _createElementVNode("br", null, null, -1 /* CACHED */))
                                                ]))
                                              }), 256 /* UNKEYED_FRAGMENT */))
                                            ]))
                                          : _createCommentVNode("v-if", true)
                                      ])
                                    ]),
                                    _: 1 /* STABLE */
                                  }, 8 /* PROPS */, ["target"])
                                ]),
                                _: 1 /* STABLE */
                              }))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_v_col, {
                        lg: "9",
                        md: "9",
                        sm: taskHelperData.value && taskHelperData.value.modalTask && taskHelperData.value.modalTask['taskStatus']['status'] == 2 ? 12 : 9,
                        xs: taskHelperData.value && taskHelperData.value.modalTask && taskHelperData.value.modalTask['taskStatus']['status'] == 2 ? 12 : 9
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_actions, { class: "justify-end" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                default: _withCtx(() => [
                                  (taskHelperData.value && taskHelperData.value.modalTask && taskHelperData.value.modalTask['taskStatus']['status'] == 2)
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 0,
                                        cols: "12",
                                        class: "d-flex justify-end mb-3"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn, {
                                            size: "small",
                                            class: "text-none",
                                            color: "black",
                                            "prepend-icon": "mdi-timer",
                                            variant: "flat",
                                            onClick: _cache[42] || (_cache[42] = ($event: any) => {taskHelperData.value.cancelTask(taskHelperData.value.modalTask['historyId']); taskHelperData.value.hideModal();})
                                          }, {
                                            default: _withCtx(() => [...(_cache[89] || (_cache[89] = [
                                              _createTextVNode("Cancel the execution", -1 /* CACHED */)
                                            ]))]),
                                            _: 1 /* STABLE */
                                          })
                                        ]),
                                        _: 1 /* STABLE */
                                      }))
                                    : _createCommentVNode("v-if", true),
                                  (taskHelperData.value && taskHelperData.value.modalTask && taskHelperData.value.modalTask['taskStatus'] && taskHelperData.value.modalTask['taskStatus']['status'] == 2)
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 1,
                                        cols: "12",
                                        class: "d-flex justify-end mb-3"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn, {
                                            size: "small",
                                            class: "text-none",
                                            color: "black",
                                            "prepend-icon": "mdi-inbox",
                                            variant: "flat",
                                            onClick: _cache[43] || (_cache[43] = ($event: any) => (taskHelperData.value.hideModal()))
                                          }, {
                                            default: _withCtx(() => [...(_cache[90] || (_cache[90] = [
                                              _createTextVNode("Run in the background", -1 /* CACHED */)
                                            ]))]),
                                            _: 1 /* STABLE */
                                          })
                                        ]),
                                        _: 1 /* STABLE */
                                      }))
                                    : _createCommentVNode("v-if", true),
                                  (taskHelperData.value && taskHelperData.value.modalTask && taskHelperData.value.modalTask['taskStatus'] && taskHelperData.value.modalTask['taskStatus']['status'] != 2)
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 2,
                                        cols: "12",
                                        class: "d-flex justify-end mt-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn, {
                                            size: "small",
                                            class: "text-none",
                                            color: "black",
                                            variant: "flat",
                                            onClick: _cache[44] || (_cache[44] = ($event: any) => {taskHelperData.value.hideModal();})
                                          }, {
                                            default: _withCtx(() => [...(_cache[91] || (_cache[91] = [
                                              _createTextVNode("Close", -1 /* CACHED */)
                                            ]))]),
                                            _: 1 /* STABLE */
                                          })
                                        ]),
                                        _: 1 /* STABLE */
                                      }))
                                    : _createCommentVNode("v-if", true)
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["sm", "xs"])
                    ]),
                    _: 1 /* STABLE */
                  })
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: createDatabaseHelperData.value.modalVisible,
      "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((createDatabaseHelperData.value.modalVisible) = $event)),
      width: "500"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _cache[92] || (_cache[92] = _createElementVNode("div", { class: "text-h6" }, "Create Database", -1 /* CACHED */)),
            _createVNode(_component_v_icon, {
              onClick: _cache[46] || (_cache[46] = ($event: any) => (createDatabaseHelperData.value.modalVisible = false)),
              icon: "mdi-close-circle cursor-pointer",
              class: "d-block"
            })
          ]),
          _createElementVNode("div", _hoisted_35, [
            _cache[94] || (_cache[94] = _createElementVNode("div", null, [
              _createElementVNode("label", { class: "font-weight-bold" }, "Enter a new database name:")
            ], -1 /* CACHED */)),
            _createVNode(_component_v_text_field, {
              density: "compact",
              variant: "outlined",
              id: "databaseName-input",
              modelValue: createDatabaseHelperData.value.newDbName,
              "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((createDatabaseHelperData.value.newDbName) = $event))
            }, null, 8 /* PROPS */, ["modelValue"]),
            _createVNode(_component_v_btn, {
              class: "text-none float-end ma-3",
              color: "black",
              loading: createDatabaseHelperData.value.isCreatingDb,
              disabled: createDatabaseHelperData.value.isCreatingDb,
              onClick: _cache[48] || (_cache[48] = ($event: any) => (createDatabaseHelperData.value.createDb()))
            }, {
              default: _withCtx(() => [...(_cache[93] || (_cache[93] = [
                _createTextVNode("Create", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["loading", "disabled"])
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})